import { render, staticRenderFns } from "./CompetitionFilterOtherLayout.vue?vue&type=template&id=55c03316&scoped=true&"
import script from "./CompetitionFilterOtherLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionFilterOtherLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c03316",
  null
  
)

export default component.exports